import { Checkbox, IconSize, IconWrapper, QuestionmarkCircleIcon, StyledFlex, Tooltip } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../translations';
import { ReceptionServiceFormController } from '../ReceptionServiceForm';

export type ReceptionServiceVideoConsultationValue = boolean;

type ReceptionServiceVideoConsultationCheckboxProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServiceVideoConsultationCheckbox = (
   props: ReceptionServiceVideoConsultationCheckboxProps
): JSX.Element => {
   return (
      <StyledFlex gap={'8px'} alignItems={'center'}>
         <Checkbox
            testId={'videoConsultation'}
            label={receptionServiceTranslationKeys.shared.form.components.videoConsultationCheckbox.label}
            controller={props.register('videoConsultation')}
            disabled={props.disabled}
            defaultValue={false}
         />
         <Tooltip
            testId={'videoConsultation'}
            content={receptionServiceTranslationKeys.shared.form.components.videoConsultationCheckbox.tooltipContent}
         >
            <IconWrapper testId={'toggleTooltipIconWrapper'} size={IconSize.SMALLEST}>
               <QuestionmarkCircleIcon />
            </IconWrapper>
         </Tooltip>
      </StyledFlex>
   );
};
